// Firebase Web SDK config for Kuryo project (kuryo-com-tr)
// Source: firebase apps:sdkconfig WEB --project kuryo-com-tr
export const FirebaseConfig = {
  apiKey: "AIzaSyAZ3HDKddjUM7lmUqz3sYeyDxEN0cpwn9A",
  authDomain: "kuryo-com-tr.firebaseapp.com",
  databaseURL: "https://kuryo-com-tr-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "kuryo-com-tr",
  storageBucket: "kuryo-com-tr.firebasestorage.app",
  messagingSenderId: "828205771146",
  appId: "1:828205771146:web:ed2e2ff08e636f216bc073",
  measurementId: "G-FN9D3YT341"
};
